var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.368922C16 0.130854 16.2818 0.00514866 16.459 0.164222L42.772 23.796C42.8938 23.9053 42.8938 24.0961 42.772 24.2054L16.4589 47.8372C16.2818 47.9963 16 47.8706 16 47.6325L16 33.6525C16 33.5726 16.0346 33.4967 16.095 33.4445L26.7598 24.2085C26.8865 24.0988 26.8865 23.9022 26.7598 23.7925L16.095 14.5565C16.0346 14.5042 16 14.4283 16 14.3485L16 0.368922Z",
    fill: "#91A0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7113 24.2333C16.8599 24.1132 16.8599 23.8868 16.7113 23.7667L9.98859 18.3327C9.7924 18.1742 9.5 18.3138 9.5 18.5661L9.5 29.4339C9.5 29.6862 9.7924 29.8258 9.98858 29.6673L16.7113 24.2333Z",
    fill: "#91A0AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRD);
export default __webpack_public_path__ + "static/media/ArrowR_D.77709abb0b11f6ad58e627e18a5a36fa.svg";
export { ForwardRef as ReactComponent };